module.exports = __webpack_public_path__ + "img/tools_bg2.514c7c41.jpg";